<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Container', apiMethod: 'Containers', form: () => import('../forms/ContainerForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Container Fill', apiMethod: 'ContainerFills', parentForeignKey: 'containerId', form: () => import('../forms/ContainerFillForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Container Test', apiMethod: 'ContainerTests', parentForeignKey: 'containerId', form: () => import('../forms/ContainerTestForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Sale Container', apiMethod: 'SaleContainers', parentForeignKey: 'buyerContainerId', form: () => import('../forms/SaleContainerForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Sale Container', apiMethod: 'SaleContainers', parentForeignKey: 'sellerContainerId', form: () => import('../forms/SaleContainerForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Fills', value: 'containerId', isCard: true, table: () => import('../tables/ContainerFillsTable') },
                    { text: 'Tests', value: 'containerId', isCard: true, table: () => import('../tables/ContainerTestsTable') },
                    { text: 'Packers', value: 'containerId', table: () => import('../tables/PackerContainersTable') },
                    { text: 'Buyings', value: 'buyerContainerId', isCard: true, table: () => import('../tables/SaleContainersTable') },
                    { text: 'Sellings', value: 'sellerContainerId', isCard: true, table: () => import('../tables/SaleContainersTable') },
                ],
                mainForm: () => import('../forms/ContainerForm'),
                claimName: 'Containers',
                apiMethod: 'Containers',
            }
        }
    };
</script>
